import { render, staticRenderFns } from "./TicketMessage.vue?vue&type=template&id=796dc4f0&scoped=true&"
import script from "./TicketMessage.vue?vue&type=script&lang=ts&"
export * from "./TicketMessage.vue?vue&type=script&lang=ts&"
import style0 from "./TicketMessage.vue?vue&type=style&index=0&id=796dc4f0&lang=scss&scoped=true&"
import style1 from "./TicketMessage.vue?vue&type=style&index=1&id=796dc4f0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "796dc4f0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/winfakt-authentication-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('796dc4f0')) {
      api.createRecord('796dc4f0', component.options)
    } else {
      api.reload('796dc4f0', component.options)
    }
    module.hot.accept("./TicketMessage.vue?vue&type=template&id=796dc4f0&scoped=true&", function () {
      api.rerender('796dc4f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ticket/TicketMessage.vue"
export default component.exports